<template>
  <div class="app-login">
    <div class="app-login-main" style="height:510px; width:800px">
      <div class="login-bg" style="-webkit-app-region:drag; text-align:center;margin-top:-159px;position:absolute;top:155px;left:270px">
        <img src="../assets/login_main.png" height="321px" width="552px" />
        <div class="app-v">
          <span>{{verInfo}}</span>
        </div>
        <div class="login-wrapper" style="height:500px;left=67%;">
          <div class="login-body">
            <img class="app-close" src="" alt="" @click="closeBtn" title="关闭">
            <div class="login-form">
              <HTabsLogin v-model="typeValue"></HTabsLogin>
              <h-form v-show="typeValue=='0'" autocomplete="off" :model="loginForm" ref="loginForm" label-position="left"
                class="card-box login-form" :label-width="56" style="width:300px;margin-left:10px;">
                <div class="login-form-wrapper">
                  <h-form-item label="用户名" prop="username" :class="{'userFocus':userFocusStatus}">
                    <h-input name="username" :type="setas" v-model="loginForm.username" :placeholder="$t('m.i.common.username')"
                      @on-focus="handlefocus('user')" @on-blur="handleblur('user')" @on-change="handleChange('user')"
                      @on-enter="handleEnter('user')" ref='username' @on-keypress="handelKeyup">
                    </h-input>
                    <div class="inputimg">
                      <img src="../assets/jt.png" :class="hasClass==='1' ? 'openlist': (hasClass==='0'?'foldlist':'')"
                        @click="showAccountList($event)" />
                    </div>
                    <ul v-show="isShowUserList" ref='loginUl'>
                      <li :class="{'selected':item.selected === true}" v-for="item in userList" :key="item" @click="changeUser(item)">
                        <span>{{item.user}}</span>
                        <img src="" alt="" @click="deleteUser(item.user)">
                      </li>
                    </ul>
                    <div class="verify-tip verify-bottom" v-show='userError'>
                      <div class="verify-tip-arrow"></div>
                      <div class="verify-tip-inner">{{userErrorInfo}}</div>
                    </div>
                  </h-form-item>
                  <h-form-item label="密码" prop="password" :class="{'pwdFocus':pwdFocusStatus}">
                    <h-input type="password" v-model="loginForm.password" autocomplete="new-password"
                      :placeholder="$t('m.i.common.tradePwdInfo')" @on-focus="handlefocus('pwd')" @on-blur="handleblur('pwd')"
                      @on-enter="handleEnter('pwd')" ref='password'>
                    </h-input>
                    <div class="inputpwd">
                      <!-- <a href="javascript:void(0)" style="width:30px;"><img src="../assets/jianpan.svg"></a> -->
                    </div>
                    <div class="verify-tip verify-bottom" v-show='passError'>
                      <div class="verify-tip-arrow"></div>
                      <div class="verify-tip-inner">{{passErrorInfo}}</div>
                    </div>
                  </h-form-item>
                  <h-form-item label="验证码" prop="checkcode" :class="{'checkFocus':checkFocusStatus}" v-if="loginHasValidateCode">
                    <h-input @on-enter="handleLogin" name="checkcode" type="text" v-model="loginForm.checkcode" autocomplete="on"
                      :placeholder="$t('m.i.common.checkcodeInfo')" ref='check'>
                    </h-input>
                    <div class="checkcode" style="width:65px;right:1px;">
                      <a href="javascript:void(0)" @click="createCode" style="width:30px;"><img :src="checkCodeUrl"
                          style="width:65px;height:28px;cursor: pointer;margin-top: -10px;"
                          :title="$t('m.i.common.refreshCode')"></a>
                    </div>
                    <div class="verify-tip verify-bottom" v-show='codeError'>
                      <div class="verify-tip-arrow"></div>
                      <div class="verify-tip-inner">{{codeErrorInfo}}</div>
                    </div>
                  </h-form-item>
                </div>
                <div class="form-item-set" style="-webkit-app-region: no-drag;">
                  <h-form-item>
                    <input type="checkbox" value="reading" :checked="remUser" @change='remember'><span>记住账号</span>
                    <input type="checkbox" value="tourist" :checked="proUser" @change='protect' style="margin-left: 20px;"><span>保护账号</span>
                  </h-form-item>
                </div>
                <div class="form-item-submit" style="-webkit-app-region: no-drag;margin:-19px 0 0 40px;z-index:1;">
                  <h-form-item style="margin-bottom: 0">
                    <h-button type="primary" style="width:120px;height:33px;" :loading="loading" @click.native.prevent="handleLogin"
                      ref="submit">
                      <span v-if="!loading">{{$t('m.i.common.login')}}</span>
                      <span v-else>登录中...</span>
                    </h-button>
                  </h-form-item>
                </div>
              </h-form>
              <ClientCellPhoneLogin v-show="typeValue=='1'"></ClientCellPhoneLogin>
            </div>
            <div class="to-reg" style="margin-bottom:20px;">
              <!--a class="reg-a" @click="browseMarket">浏览行情</a>
              <a>|</a-->
              <a class="reg-a" @click="forget">忘记密码</a>
              <a> | </a>
              <a class="reg-a" @click="webCommon">注册新用户</a>
              <a> | </a>
              <a class="reg-a" @click="goQuotation">浏览行情</a>
            </div>
          </div>
        </div>
        <!-- 检测更新 -->
        <h-msg-box v-model="showProgressInfo" title='检测更新' :closable="false" :mask-closable="false" top="55" width="300">
          <!--显示提示信息-->
          <div v-bind:style="{display:displayStateOne}">
            <p style="margin-top:-19px;white-space:pre-line;">{{showInfo}}</p>
            <h-progress v-bind:style="{display:displayStateThree}" :percent='updatePercent'></h-progress>
          </div>
          <!-- 有更新版本时显示 ---强制下载更新-->
          <div slot="footer" v-bind:style="{display:displayStateFour}">
            <h-button :disabled='disable' type="primary" style="margin:0 8px" @click="startUpdate()">确定</h-button>
          </div>
          <!-- 有更新版本时显示--可选下载更新 -->
          <div slot="footer" v-bind:style="{display:displayStateTwo}">
            <h-button :disabled='disable' type="primary" @click="startUpdate()">确认</h-button>
            <h-button :disabled='disable' @click="closeUpdate()">取消</h-button>
          </div>
        </h-msg-box>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckCode, getIp } from '@frame/api/login/index'
import { getExtPublicKey, getExtSysConfig } from '@frame/api/common/index'
import { encrypt } from '@frame/utils/Utils'
import Cookies from 'js-cookie'
import cloneDeep from 'clone-deep'
import HTabsLogin from '@frame/views/loginMode/HTabsLogin'
import ClientCellPhoneLogin from '@frame/views/loginMode/clientCellPhoneLogin'
export default {
  name: 'login',
  components: {
    HTabsLogin,
    ClientCellPhoneLogin
  },
  data () {
    return {
      remUser: false,
      proUser: false,
      setas: 'text',
      isShowUserList: false,
      hasClass: '0',
      userList: [],
      // 公钥
      publicKey: '',
      // 系统名
      sysName: window.LOCAL_CONFIG.SYS_NAME,
      loginHasValidateCode: true,
      checkCodeUrl: '',
      cityList: [
        {
          value: 'beijing',
          label: '行情主站1'
        },
        {
          value: 'shanghai',
          label: '行情主站2'
        }
      ],
      loginForm: {
        market: '',
        username: '',
        password: '',
        checkcode: '',
        checktoken: ''
      },
      randomCode: '',
      loading: false,
      showDialog: false,
      marError: false,
      marErrorInfo: '',
      userError: false,
      userErrorInfo: '',
      codeError: false,
      codeErrorInfo: '',
      passError: false,
      passErrorInfo: '',
      marketFocusStatus: false,
      userFocusStatus: false,
      pwdFocusStatus: false,
      checkFocusStatus: false,
      tenantFocusStatus: false,
      animationSpeed: 1,
      tenantData: [],
      tenantListShow: false,
      isShowTenant: false,
      show: true,
      timer: null,
      count: 1,
      targetPath: '',
      unTargetPath: '',
      showProgressInfo: false,
      showInfo: '',
      disable: false,
      updatePercent: 0,
      updateType: 0,
      displayStateOne: 'none',
      displayStateTwo: 'none',
      displayStateThree: 'none',
      displayStateFour: 'none',
      deleteUserState: false,
      version: '1.0.0',
      typeValue: '0'
    }
  },
  computed: {
    verInfo () {
      return `V${this.version}`
    }
  },
  watch: {
    'loginForm.checkcode': {
      handler: function () {
        this.codeError = false
      },
      deep: true
    },
    'loginForm.password': {
      handler: function () {
        this.passError = false
      },
      deep: true
    },
    'loginForm.username': {
      handler: function () {
        this.passError = false
      },
      deep: true
    },
    userList: {
      handler: function () {
        this.$hLoading.finish()
        this.$nextTick(() => {
          if (this.isShowUserList) {
            var info = this.$refs.loginUl
            if (this.userList.length <= 5) {
              info.style = 'overflow-y: hidden;height:auto;'
            }
          }
        })
      },
      deep: true
    }
  },
  methods: {
    currentTime () {
      let date = new Date()
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      var h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      var minute = date.getMinutes()
      minute = minute < 10 ? ('0' + minute) : minute
      var second = date.getSeconds()
      second = second < 10 ? ('0' + second) : second
      return '' + y + m + d + h + minute + second
    },
    changeUser (data) {
      console.log(data)
      if (this.deleteUserState) {
        this.deleteUserState = false
        return
      }
      this.loginForm.username = data.user
      this.cityList.map(item => {
        item.selected = false
        if (item.value === data.value) {
          item.selected = true
        }
      })
      this.hasClass = '0'
      this.isShowUserList = false
    },
    showAccountList (e) {
      this.isShowUserList = !this.isShowUserList
      if (this.isShowUserList) {
        this.hasClass = '1'
        var info = this.$refs.loginUl
        if (this.userList.length > 5) {
          info.style = 'overflow-y: scroll;height:110px;'
        } else {
          info.style = 'overflow-y: hidden;height:auto;'
        }
      } else {
        this.hasClass = '0'
      }
    },
    getUserInfo () {
      if (typeof (this.$localStore.get('userlist')) !== 'undefined') {
        var userinfo = this.$localStore.get('userlist')
        var arr = new Array(userinfo.length) // 存储时间值
        var timeList = []
        this.userList = []
        for (let k = 0; k < userinfo.length; k++) {
          arr[k] = userinfo[k].time
        }
        timeList = arr.sort().reverse()
        for (let i = 0; i < timeList.length; i++) {
          for (let j = 0; j < userinfo.length; j++) {
            console.log(timeList[i])
            console.log(userinfo[j].time)
            if (timeList[i] === userinfo[j].time) {
              if (i === 0) {
                this.loginForm.username = userinfo[j].user
              }
              this.userList.push({ user: userinfo[j].user, time: userinfo[j].time })
            }
          }
        }
        this.remUser = this.$localStore.get('remUser')
        this.proUser = this.$localStore.get('proUser')
        if (this.proUser) {
          this.setas = 'password'
        } else {
          this.setas = 'text'
        }
      } else {
        this.$localStore.set('userlist', this.userList)
        this.$localStore.set('remUser', this.remUser)
        this.$localStore.set('proUser', this.proUser)
      }
    },
    updateUserInfo () {
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].user === this.loginForm.username) {
          this.userList.splice(i, 1)
          break
        }
      }
      // 如果遍历没有查到，记住密码的话，则添加
      if (this.remUser) {
        this.userList.push({ user: this.loginForm.username, time: this.currentTime() })
      }
      this.$localStore.set('userlist', this.userList)
      this.$localStore.set('remUser', this.remUser)
      this.$localStore.set('proUser', this.proUser)
    },
    remember () {
      if (this.remUser) {
        this.remUser = false
      } else {
        this.remUser = true
      }
    },
    protect () {
      if (this.proUser) {
        this.setas = 'text'
        this.proUser = false
      } else {
        this.setas = 'password'
        this.proUser = true
      }
    },
    // 设置cookie
    setCookie (name, rem, pro, exdays) {
      var now = new Date() // 获取时间
      now.setTime(now.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie' ;toGMTString() 方法可根据格林威治时间 (GMT) 把 Date 对象转换为字符串，并返回结果
      window.document.cookie = 'userName' + '=' + name + ';time=' + now.toGMTString()
      window.document.cookie = 'remUser' + '=' + rem + ';time=' + now.toGMTString()
      window.document.cookie = 'proUser' + '=' + pro + ';time=' + now.toGMTString()
    },
    // 读取cookie
    getCookie () {
      console.log('cookcookcook')
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        console.log(arr)
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.loginForm.username = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] === 'remUser') {
            if (arr2[1] === 'false') {
              this.remUser = false
            } else {
              this.remUser = true
            }
          } else if (arr2[0] === 'proUser') {
            if (arr2[1] === 'false') {
              this.proUser = false
              this.setas = 'text'
            } else {
              this.proUser = true
              this.setas = 'password'
            }
          }
        }
      }
    },
    // 刷新cookie
    refreshCookie () {
      this.setCookie('', this.remUser, this.proUser, -1) // 修改2值都为空，天数为负1天就好了
    },
    browseMarket () {
      this.$router.push({ path: '' })
    },
    webCommon () {
      // 发送同步消息放大界面
      this.$myIpcSend.ipcSender(this.$router, 'reg&forget', '', '/regCommon')
    },
    goQuotation () {
      this.$hLoading.start()
      // 发送同步消息放大界面
      this.$myIpcSend.ipcSender(this.$router, 'open-main-win', 'quotation', '/quotation')
    },
    regCompany () {
      this.$router.push({ path: '/regCompany' })
    },
    regPerson () {
      this.$router.push({ path: '/regPerson' })
    },
    forget () {
      this.$router.push({ path: '/forget' })
    },
    // 获取公钥
    getRsaPublickKey () {
      getExtPublicKey({}).then(r => {
        if (r.data.success) {
          this.publicKey = r.data.publicKey
        } else {
          this.$hMessage.warning('获取系统公钥失败')
        }
      }).catch(e => {
        this.$hMessage.error({
          content: '获取系统公钥异常,请确认服务是否正常',
          duration: 5
        })
        console.log(e)
      })
    },
    // 获取系统名称
    getDbSysConfig () {
      getExtSysConfig({ 'code': 'name_of_exchange' }).then(r => {
        if (r.data.success) {
          this.sysName = r.data.value
        }
      }).catch(e => {
        console.log(e)
      })
    },
    toast (type, message, duration = 1) {
      const cfg = { content: message, duration: duration, closable: true }
      switch (type) {
        case 'warning':
          this.$hMessage.warning(cfg)
          break
        case 'success':
          this.$hMessage.success(cfg)
          break
        case 'error':
          this.$hMessage.error(cfg)
          break
        default:
          this.$hMessage.info(cfg)
      }
    },
    isError (r) {
      const d = r.data
      if (!d) {
        this.toast('error', '后台返回的数据格式不正确')
        return false
      }
      if (d.errorNo && d.errorNo !== '0') {
        this.toast('error', d.errorInfo)
        return true
      }
      return false
    },
    /* 关闭 */
    closeBtn () {
      this.$localStore.set('reload', false)
      this.$myIpcSend.ipcSender(this.$router, 'window-close')
    },
    /* 登录 */
    handleLogin () {
      if (this.loginForm.username === '') {
        this.userError = true
        this.userErrorInfo = this.$t('m.i.login.userErr')
        return
      } else if (this.loginForm.password === '') {
        this.passError = true
        this.passErrorInfo = this.$t('m.i.login.pwdErr')
        return
      }
      this.loading = true
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let pwd = this.loginForm.password
          let param = cloneDeep(this.loginForm)
          param.password = encrypt(pwd, this.publicKey)
          this.$store.dispatch('loginOtp', param).then((res) => {
            if (res.errorNo === '0') {
              // 重新登录，获取导航的值，设置false，判断重新获取
              this.$store.commit('SET_DET_MENU', false)
              this.$store.dispatch('getUserImage', '')
              this.$myIpcSend.ipcSender(this.$router, 'open-main-win', '', '/uc-index')
              // 登录成功，记住用户名、密码
              this.updateUserInfo()
            } else if (res.errorNo === '201014') {
              this.codeError = true
              this.codeErrorInfo = res.errorInfo
              this.loading = false
              this.refreshCode()
            } else {
              this.passError = true
              this.passErrorInfo = res.errorInfo
              this.loading = false
              this.refreshCode()
            }
          }).catch(e => {
            this.loading = false
            console.error(e)
          })
        }
      })
    },
    refreshCode () {
      this.createCode()
    },
    handleEnter (param) {
      switch (param) {
        case 'user':
          this.$refs.password.focus()
          break
        case 'pwd':
          this.$refs.check.focus()
          break
        case 'check':
          this.handleLogin()
          break
      }
    },
    handlefocus (type) {
      if (type === 'mar') this.marFocusStatus = true
      if (type === 'user') this.userFocusStatus = true
      if (type === 'pwd') this.pwdFocusStatus = true
      if (type === 'check') this.checkFocusStatus = true
      if (this.isShowUserList) {
        this.isShowUserList = false
      }
      this.hasClass = '0'
    },
    handleblur (type) {
      if (type === 'mar') {
        this.marFocusStatus = false
      }
      if (type === 'user') {
        this.userFocusStatus = false
        this.createCode()
      }
      if (type === 'pwd') {
        this.pwdFocusStatus = false
      }
      if (type === 'check') {
        this.checkFocusStatus = false
      }
    },
    handleChange (type) {
      if (type === 'user') {
        this.userError = false
      }
      if (type === 'check') {
        this.codeError = false
      }
    },
    codeBlur () {

    },
    nameBlur () {

    },
    pwdBlur () {

    },
    /* 生成验证 */
    createCode () {
      getCheckCode({}).then(r => {
        if (r.success) {
          this.checkCodeUrl = r.data
          this.loginForm.checktoken = r.token
        }
      }).catch(e => {
        this.$hMessage.error({
          content: '刷新验证码失败,请确认服务是否正常',
          duration: 5
        })
        console.error(e)
      })
    },
    /* 下载 */
    downloadFile (path, version) {
      // app.zip 文件包含打包下的dist和package.json两个文件，增量更新时，解压到原有的app目录下，完成更新，重启生效
      var file_url = `${window.LOCAL_CONFIG.downlodurl}${version}.zip`
      console.log('file_url ' + file_url)
      var received_bytes = 0
      var total_bytes = 0
      var req = window.request({
        method: 'GET', uri: file_url
      })

      var out = window.fs.createWriteStream(this.targetPath)
      req.pipe(out)

      req.on('response', function (data) {
        total_bytes = parseInt(data.headers['content-length'])
      })
      var that = this
      req.on('data', function (chunk) {
        received_bytes += chunk.length

        that.showProgress(received_bytes, total_bytes)
      })

      req.on('end', function () {
        console.log('File succesfully downloaded')
        that.$myIpcSend.ipcSender(this.$router, 'succesfully')
      })
    },
    // 检测文件是否存在
    checkDocument (path, version) {
      // 更新增量压缩包路径
      this.targetPath = `${path}/../../../${version}.zip`
      window.logger.info('增量更新压缩包路径:' + this.targetPath)
      // 解压增量压缩包路径
      this.unTargetPath = `${path}/../../../app/`
      // 检测更新时判断文件是否存在
      window.fs.access(this.targetPath, (err) => {
        if (!err) {
          console.log('文件存在')
          this.$myIpcSend.ipcSender(this.$router, 'succesfully')
          this.$myIpcSend.ipcSender(this.$router, 'isIncrement', 100)
        } else {
          this.downloadFile(path, version)
        }
      })
    },
    showProgress (received, total) {
      var percentage = (received * 100) / total
      console.log('percentage:' + percentage)
      this.$myIpcSend.ipcSender(this.$router, 'isIncrement', percentage)
    },
    startDealWith () {
      // 备份原有的文件
      var tarzip = new window.Admzip()
      tarzip.addLocalFile(this.unTargetPath + 'package.json')
      tarzip.addLocalFolder(this.unTargetPath + 'dist')
      tarzip.writeZip(this.unTargetPath + window.dayjs().format('YYYY-MM-DD-HH-mm-ss') + '.zip')
      // 解压覆盖
      var unzip = new window.Admzip(this.targetPath)
      unzip.extractAllTo(this.unTargetPath, true)

      // 删除下载文件
      window.fs.unlink(this.targetPath, (err) => {
        if (err) {
          throw err
        }
        console.log('文件:' + this.targetPath + '删除成功！')
        // 提示安装完成
        this.$myIpcSend.ipcSender(this.$router, 'installSuccess')
      })
    },
    // 显示检测更新对话框
    startUpdate () {
      if (this.updateNow) {
        // 开始安装
        this.showInfo = '正在安装...'
        this.disable = true
        this.displayStateThree = 'none'
        this.$myIpcSend.ipcSender(this.$router, 'isUpdateNow', this.updateType)
      } else {
        this.displayStateThree = 'inline' // 显示进度条
        this.showInfo = '正在下载'
        this.updatePercent = 0
        this.disable = true
        if (this.updateType === 3) {
          // 全量更新
          this.$myIpcSend.ipcSender(this.$router, 'isDownloadNow')
        } else {
          // 增量更新
          this.$myIpcSend.ipcSender(this.$router, 'isIncrement', 'loginWindow')
        }
      }
    },
    // 关闭检测更新对话框
    closeUpdate () {
      this.showProgressInfo = false
      this.updateNow = false
    },
    // 删除用户
    deleteUser (event) {
      console.log('删除用户:' + event)
      this.deleteUserState = true
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].user === event) {
          if (this.loginForm.username === event) {
            this.loginForm.username = ''
          }
          this.userList.splice(i, 1)
          break
        }
      }
      this.$localStore.set('userlist', this.userList)
    }
  },
  created () {
    document.getElementsByTagName('html')[0].className = Cookies.get('theme') ? Cookies.get('theme') : window.LOCAL_CONFIG.THEME
    document.body.className = 'login'
    let isUrlLowercase = window.LOCAL_CONFIG.isUrlLowercase + ''
    if (isUrlLowercase === 'true') {

    }
    const me = this
    // 获取本机IP地址
    getIp({}).then(r => {
      if (r.data.success) {
        Cookies.set('clientIp', r.data.ip)
        me.$localStore.set('clientIp', r.data.ip)
        me.getRsaPublickKey()
      } else {
        this.$hMessage.error('获取ip地址失败')
      }
    }).catch(e => {
      this.$hMessage.error(e.message)
    })
    // 获取系统名称
    me.getDbSysConfig()
  },
  mounted () {
    window.addEventListener('mousedown', () => {
      console.log('---------------------------')
    })
    this.$myIpcSend.renderer().on('version', (event, data) => {
      this.version = data.version
    })
    if (this.loginHasValidateCode) {
      this.createCode()
    }
    let _self = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key === 38) _self.up()
      if (key === 40) _self.down()
    }
    this.$refs.username.focus()
    // 监听刷新事件
    this.$myIpcSend.renderer().on('refresh', event => {
      this.loginForm.username = ''
      this.loginForm.password = ''
      this.loginForm.checkcode = ''
      this.loading = false
      this.createCode()
      this.getUserInfo()
    })
    this.$nextTick(() => {
      console.log('send downUrl')
      var logPath = this.$myIpcSend.renderer().sendSync('downUrl', window.LOCAL_CONFIG.downlodurl, window.LOCAL_CONFIG.updateType, window.LOCAL_CONFIG.isUpdate)
      window.logger.transports.file.file = logPath
      window.logger.transports.file.level = 'debug'
      window.logger.transports.console.level = 'debug'
      window.logger.info('加载完成')
      // 检测更新
      if (window.LOCAL_CONFIG.isUpdate) {
        this.$myIpcSend.ipcSender(this.$router, 'checkForUpdate')
      }
    })
    this.getUserInfo()
    // 监听下载事件
    this.$myIpcSend.renderer().on('dirpath', (event, path, version) => {
      console.log('receive dirpath')
      this.checkDocument(path, version)
    })
    // 监听开始更新事件
    this.$myIpcSend.renderer().on('startUpdate', (event, data) => {
      this.startDealWith()
    })
    // 监听新版版
    this.$myIpcSend.renderer().on('message', (event, text) => {
      console.log(event, text)
      if (text.type === 3 || text.type === 5) {
        // 判断有更新时，安装方式
        if (window.LOCAL_CONFIG.updateType !== 2) {
          if (window.LOCAL_CONFIG.updateType === 0) {
            this.displayStateTwo = 'inline'
          } else if (window.LOCAL_CONFIG.updateType === 1) {
            this.displayStateFour = 'inline'
          }
          this.showProgressInfo = true
          this.displayStateOne = 'inline'
          this.displayStateThree = 'none'
          this.updatePercent = 0
          this.updateType = text.type
          this.showInfo = `检测到新版本v${text.version}，是否下载更新？\n${text.detail}`
        } else {
          this.$myIpcSend.ipcSender(this.$router, 'isDownloadNow')
        }
      }
    })
    this.$myIpcSend.renderer().on('isUpdateNow', (event, data) => {
      this.updateNow = true
    })
    this.$myIpcSend.renderer().on('updateProcess', (event, data) => {
      console.log('接收数据:' + data)
      this.updatePercent = parseInt(data)
      if (this.updatePercent === 100) {
        this.disable = false
        if (window.LOCAL_CONFIG.updateType === 0) {
          this.showInfo = '下载完成，是否进行安装？'
        } else if (window.LOCAL_CONFIG.updateType === 1) {
          this.updateNow = true
          this.startUpdate()
        }
      }
    })
    this.$myIpcSend.renderer().on('updateSuccess', (event, data) => {
      this.showInfo = '安装成功，重启后生效'
      this.$myIpcSend.ipcSender(this.$router, 'logout', 1)
    })
  },
  destroyed () {
    document.body.className = ''
    console.log('destroyed..............................................')
  },
  beforeDestroy () { // 在组件生命周期结束的时候销毁。
    document.body.removeEventListener('click', this.bodyClick, false)
    this.$myIpcSend.renderer().removeAllListeners()

    this.$hLoading.finish()
  },
  beforeCreate () {
    localStorage.setItem('lang', 'zh-CN')
    Cookies.set('lang', 'zh-CN')
    this.$i18n.locale = 'zh-CN'
  }
}
</script>

<style scoped lang="scss">
.to-reg {
  /* margin-top: -15px; 选择行情时展开*/
  margin-top: 1px;
  margin-left: -70px;
  -webkit-app-region: no-drag;
  width: 380px;
}
.reg-a {
  margin: 8px;
}
.app-login-main {
  position: absolute !important;
}

.app-login-main /deep/ .h-form-item-label {
  vertical-align: middle;
  float: left;
  font-size: 12px;
  color: #333;
  background: #fff !important;
  line-height: 28px;
  padding: 0 10px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-top: 0px !important;
  text-align: justify;
  text-align-last: justify;
}

.app-login-main /deep/ .h-input-group-prepend {
  width: 41px;
  background: #fff;
  border-radius: 4% !important;
  border: 1px solid #eee;
  border-right: 0;
  height: 50% !important;
}

.app-login-main /deep/ .h-input {
  height: 30px !important;
  widows: 100px !important;
  padding-left: 11px !important;
  border-radius: 4% !important;
  border: 1px solid #eee !important;
  border-left: 10 !important;
  background-color: #fff !important;
  color: #333 !important;
  -webkit-app-region: no-drag !important;
}

.app-login-main /deep/ .h-btn {
  width: 10px;
  height: 33px !important;
  background-image: linear-gradient(
    -147deg,
    #ff9141 0,
    #ff9141 100%
  ) !important;
  border-radius: 5px !important;
  border-color: #fff;
  margin-left: -120px !important;
  margin-top: 3px !important;
}
.app-login-main /deep/ .h-btn:hover {
  background-image: linear-gradient(
    -147deg,
    #f3caa8 0,
    #f3caa8 100%
  ) !important;
}

.app-login-main /deep/ .login-body {
  width: 300px !important;
  height: 313px !important;
  /* padding: 20px 40px 68px 32PX !important; */
  border-radius: 1px !important;
  background: #fff !important;
  position: absolute;
  top: 98px;
  left: -170px;
  padding-top: 10px !important;
}

.app-login-main /deep/ .login-form {
  margin-left: -2px !important;
  /* margin-top: 17px !important; 显示行情选择，用此布局*/
  margin-top: 0px !important;
}

.app-login-main /deep/ .login-wrapper {
  top: 49.5% !important;
  left: 66% !important;
  margin: -255px 0 0 0 !important;
  width: 330px !important;
}

.app-login-main /deep/ .login-form-wrapper {
  width: 234px !important;
}

.app-login-main /deep/ .h-form-item {
  position: relative !important;
  height: 34px !important;
  margin-bottom: 10px !important;
}

.app-login-main /deep/ .verify-tip.verify-bottom {
  margin-top: -19px;
  padding: 5px 0;
  line-height: 17px;
}

.inputpwd {
  z-index: 999;
  position: absolute;
  top: -5px;
  right: 30px;
  width: 0px;
  height: 8px;
  border-radius: 4px;
  margin-left: 0px;
}
.inputpwd img {
  width: 30px;
  height: 20px;
  cursor: pointer;
  margin-left: -3px;
  margin-top: 10px;
}
.inputimg {
  z-index: 999;
  position: absolute;
  top: 8px;
  right: 30px;
  width: 0px;
  height: 8px;
  border-radius: 4px;
  margin-left: 0px;
}
.app-logo {
  position: absolute;
  top: 30px;
  left: 170px;
}
.app-close {
  position: absolute;
  left: 276px;
  top: 3px;
  width: 25px;
  height: 25px;
  background: white url(../assets/close.svg) no-repeat;
  background-position: center;
  -webkit-app-region: no-drag;
  outline: none;
}
.app-close:hover {
  border-top-right-radius: 2px;
  background: red url(../assets/close.svg) no-repeat;
  background-position: center;
  -webkit-app-region: no-drag;
}
.app-logo span {
  padding-left: 8px;
  color: #fff;
  font-size: 14px;
}
.app-v {
  position: absolute;
  top: 10px;
  left: 140px;
}
.app-v span {
  position: absolute;
  top: 270px;
  left: 23px;
  color: #fff;
  font-size: 16px;
}
.form-item-set {
  margin-top: -9px;
  margin-left: -64px;
}
.form-item-set input {
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 4px;
}
.app-login-main /deep/ .h-checkbox-wrapper {
  margin-left: 19px !important;
}
ul {
  width: 178px;
  background-color: transparent;
  /* border-radius: 4px; */
  border: 1px solid #fff;
  list-style: none;
  padding: 0;
  margin-top: -12px;
  position: absolute;
  -webkit-app-region: no-drag;
  margin-left: -1px;
  z-index: 10000 !important;
  /* height: 110px; */
  /* overflow-y: scroll; */
}
li {
  height: 21px;
  width: 100%;
  padding: 0 12px;
  text-align: left;
  /* margin-left: -12px; */
  line-height: 18px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: #71797c;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
li img {
  width: 16px;
  height: 16px;
  float: right;
  margin-top: 2px;
}
li:hover {
  background-color: #d1dadd;
  color: #25687e;
}
li:hover img {
  background: url(../assets/close1.svg) no-repeat;
}
li:hover img:hover {
  background: url(../assets/close2.svg) no-repeat;
}
li.selected {
  background-color: white;
  color: #25687e;
}
/* 展开： */
.openlist {
  -webkit-animation: open 0.3s linear forwards;
  animation: open 0.3s linear forwards;
  -webkit-app-region: no-drag;
}
/* 收起： */
.foldlist {
  -webkit-animation: fold 0.3s linear forwards;
  animation: fold 0.3s linear forwards;
  -webkit-app-region: no-drag;
}

.login-tabs {
  margin: 0 !important;
  /deep/.h-tabs-bar {
    margin-top: 0;
    margin-bottom: 20px;
  }
  /deep/.h-tabs-nav .h-tabs-tab {
  }
}
@-webkit-keyframes open {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(180deg);
  }
}
@keyframes open {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
}
@-webkit-keyframes fold {
  from {
    -webkit-transform: rotate(180deg);
  }
  to {
    -webkit-transform: rotate(0deg);
  }
}
@keyframes fold {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
}
</style>
